<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong> removed a banned word:-->
<!--        <strong>{{ $_.get(activity, "payload.name") }}</strong>-->
        <span v-html="$t('notification.bannedWordRemoved', {user:$_.get(activity, 'actorUser.name'),bWord:$_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "BannedWordRemoved",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
